import { FC } from 'react';
import { useForm } from 'react-hook-form';

import {
  initNotificationFormFields,
  type NotificationFormFields,
} from 'page/NotificationPage/types/notificationFormField';
import {
  useCustomerStore,
  useRegistrationStore,
} from 'page/NotificationPage/hooks';
import { InputModal } from './InputModal';
import { ConfirmationModal } from './ConfirmationModal';

export const RegistrationModal: FC = () => {
  const {
    init: initRegistration,
    setForm,
    goSecondModal,
    goFirstModal,
    postNotificationAndReload,
  } = useRegistrationStore();
  const { init: initCustomers } = useCustomerStore();

  const { control, formState, register, getValues, reset } =
    useForm<NotificationFormFields>({
      defaultValues: initNotificationFormFields,
      mode: 'all',
    });

  /**
   * モーダルを閉じたときにおこなう一連の初期化処理
   */
  const initState = () => {
    // フォームをリセット
    reset();
    // 登録画面の state を初期化
    initRegistration();
    // 顧客一覧の state を初期化
    initCustomers();
  };

  /**
   * 入力モーダル・確認モーダルで右上の「×」ボタンをクリックしたときの処理
   */
  const handleClose = () => {
    // 初期化
    initState();
  };

  /**
   * 入力モーダルで「確認」ボタンをクリックしたときの処理
   */
  const handleClickGoSecond = () => {
    // フォームの内容を state に保存
    setForm(getValues());
    // 確認モーダルに進む
    goSecondModal();
  };

  /**
   * 確認モーダルで「入力画面に戻る」ボタンをクリックしたときの処理
   */
  const handleClickGoFirst = () => {
    // 入力モーダルに戻る
    goFirstModal();
  };

  /**
   * 確認モーダルで「登録ボタン」をクリックしたときの処理
   */
  const handleClickRegistration = () => {
    // お知らせ登録処理＆一覧をリロード
    void postNotificationAndReload();
    // 初期化
    initState();
  };

  return (
    <>
      {/* 入力モーダルコンテナ */}
      <InputModal
        control={control}
        formState={formState}
        register={register}
        getValues={getValues}
        handleClose={handleClose}
        handleClickGoSecond={handleClickGoSecond}
      />
      {/* 確認モーダルコンテナ */}
      <ConfirmationModal
        handleClose={handleClose}
        handleClickGoFirst={handleClickGoFirst}
        handleClickRegistration={handleClickRegistration}
      />
    </>
  );
};
